// This is an example of an instance class to use for redux resources
// It will allow us to give our resources instance methods (ex. event.print(), event.signatureString())
export class Events {
  // printFunction = () => {
  //   console.log("this? ", this);
  //   console.log("printing! I'm a class instance method");
  // };
}
